const searchBtn = document.querySelector('.search-btn');
const search = document.querySelector('.header__search');
const headerArticleLine = document.querySelector('.header-article-line');

let isFocused = false;
searchBtn.addEventListener('click', () => {
  const header = document.querySelector('.header');
  const isFixedHeader = !!document.querySelector('.header_is-fixed');
  searchBtn.querySelector('.search-btn__show-icon').classList.toggle('hidden');
  searchBtn.querySelector('.search-btn__close-icon').classList.toggle('hidden');

  search.classList.toggle('header__search_show');
  headerArticleLine?.classList?.toggle('hidden');
  if (!isFocused) {
    search.querySelector("input[type='search'")?.focus();
    if (isFixedHeader)
      header.classList.toggle("header_fixed-with-search")
    else {
      if (!header.classList.contains('header_small'))
        header.classList.toggle("header_with-search")
      else
        header.classList.toggle("header_with-search-small")
    }
    isFocused = true;
  } else {
    if (isFixedHeader)
      header.classList.toggle("header_fixed-with-search")
    else {
      if (!header.classList.contains('header_small'))
        header.classList.toggle("header_with-search")
      else
        header.classList.toggle("header_with-search-small")
    }
    isFocused = false;
  }
});
